import { render, staticRenderFns } from "./Qualidade4.vue?vue&type=template&id=fdcb773a&scoped=true&"
import script from "./Qualidade4.vue?vue&type=script&lang=js&"
export * from "./Qualidade4.vue?vue&type=script&lang=js&"
import style0 from "./Qualidade4.vue?vue&type=style&index=0&id=fdcb773a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcb773a",
  null
  
)

export default component.exports